import React, { useMemo } from 'react';
import { GET_LIST, useListContext, useQuery } from 'react-admin';

import { SID_MEMBER_TYPES } from '@hisports/common/src/constants';
import { FF_SID_MEMBER_TYPES } from '@hisports/common/featureFlags';

import { useSeason } from '../../common/inputs/SeasonSelector';
import { useFlag } from '../../http';
import { ParticipantField } from '../participants/ParticipantField';
import { OfficeField } from '../offices/OfficeField';
import { AffiliationField, AffiliationLabel } from '../memberTypes/AffiliationField';
import { OfficialDatagrid } from './OfficialModal';

export const useParticipantMemberTypes = (enabled = true, participantIds, seasonId) => useQuery({
  type: GET_LIST,
  resource: 'participantMemberTypes',
  payload: {
    filter: {
      participantId: { inq: participantIds },
      isActive: true,
      'memberType.type': SID_MEMBER_TYPES.official,
      seasonId,
      _include: 'memberType'
    },
  }
},
{
  enabled: !!participantIds?.length && enabled,
})

export const OfficialGrid = ({ ...props }) => {
  const seasonId = useSeason();
  const isEnabled = useFlag();
  const { data: officials } = useListContext();
  const participantIds = useMemo(() => Object.values(officials).map(official => official.participantId), [officials]);
  const showMemberType = isEnabled(FF_SID_MEMBER_TYPES);

  const { data: memberTypes } = useParticipantMemberTypes(showMemberType, participantIds, seasonId);

  return <OfficialDatagrid size="medium" {...props}>
    <ParticipantField source="participantId" label="resources.officials.fields.participantId" includeId="inline" />
    <OfficeField source="officeId" label="resources.officials.fields.officeId" />
    {showMemberType && <AffiliationField label={<AffiliationLabel />} source="participantId" memberTypes={memberTypes} />}
  </OfficialDatagrid>
}
